// Thinking status messages that rotate every 10 seconds
export const THINKING_STATUS_MESSAGES = [
  {
    text: "Understanding your request...",
    icon: "🧠",
    description: "Analyzing your question"
  },
  {
    text: "Processing information...",
    icon: "⚙️",
    description: "Working through the data"
  },
  {
    text: "Fetching relevant data...",
    icon: "🔍",
    description: "Searching for information"
  },
  {
    text: "Analyzing patterns...",
    icon: "📊",
    description: "Identifying key insights"
  },
  {
    text: "Generating response...",
    icon: "✨",
    description: "Creating your answer"
  },
  {
    text: "Formatting results...",
    icon: "📝",
    description: "Structuring the response"
  },
  {
    text: "Almost done...",
    icon: "🎯",
    description: "Finalizing details"
  },
  {
    text: "Preparing response...",
    icon: "🚀",
    description: "Getting ready to deliver"
  }
];

// Configuration for status rotation
export const THINKING_CONFIG = {
  ROTATION_INTERVAL: 10000, // 10 seconds in milliseconds
  FADE_DURATION: 500, // Fade transition duration
  MIN_DISPLAY_TIME: 2000, // Minimum time to show each message
};

// Helper function to get status message by index
export const getStatusMessage = (index) => {
  return THINKING_STATUS_MESSAGES[index % THINKING_STATUS_MESSAGES.length];
};

// Helper function to get total number of status messages
export const getTotalStatusCount = () => {
  return THINKING_STATUS_MESSAGES.length;
};
